import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { EmptyResults } from '@/components/ats';
import { ConversationContent } from './ConversationContent';
import { AppReview } from '@/assets/icons/ats/empty';

export const ConversationSection = ({
  title,
  data,
  handleReplyClick,
  handleCandidateReply,
  handleSendNow,
  handleDeleteEmail,
  handleEditEmail,
  itemWrappers = {},
  isFromApplication = false,
  isUpdating = false,
  onRefetchScheduled = () => {},
  onEditInternalEmail,
  transferInfo = null,
  transfer_info = null,
  candidateName = null,
  isAiSessionsLoading = false,
}) => {
  return (
    <AccordionItem border="none" {...itemWrappers}>
      <AccordionButton
        w="100%"
        _focus={{ boxShadow: 'none' }}
        borderBottom="1px solid"
        borderColor="border-color"
        justifyContent="space-between"
        p="0"
        h="54px"
        bg="secondary-25"
        _hover={{}}
      >
        <Center
          w="54px"
          h="100%"
          borderRight="1px solid"
          borderColor="border-color"
        >
          <AccordionIcon />
        </Center>
        <Flex flex="1" alignItems="center">
          <Box
            fontSize="md-semi-bold"
            px="12px"
            color="secondary-900"
            data-test-id={`conversation-section-${title
              ?.toLowerCase()
              ?.replace(/ /g, '-')}`}
          >
            {title}
          </Box>
          <Box
            border="1px solid"
            borderColor="border-color"
            p="1px 5px"
            borderRadius="6px"
            bg="base-white"
            minW={'28px'}
          >
            {data?.length || 0}
          </Box>
        </Flex>
      </AccordionButton>
      <AccordionPanel p="4px 14px">
        {isAiSessionsLoading && (!data || data.length === 0) ? (
          <Center
            minH="160px"
            py="24px"
            data-test-id="conversation-section-ai-sessions-loading"
          >
            <Spinner color="primary-800" size="lg" thickness="4px" />
          </Center>
        ) : data?.length > 0 ? (
          <ConversationContent
            conversations={data}
            handleReplyClick={handleReplyClick}
            handleCandidateReply={handleCandidateReply}
            handleSendNow={handleSendNow}
            handleDeleteEmail={handleDeleteEmail}
            handleEditEmail={handleEditEmail}
            isFromApplication={isFromApplication}
            isUpdating={isUpdating}
            onRefetchScheduled={onRefetchScheduled}
            onEditInternalEmail={onEditInternalEmail}
            transferInfo={transferInfo}
            transfer_info={transfer_info}
            candidateName={candidateName}
            isAiSessionsLoading={isAiSessionsLoading}
          />
        ) : (
          <EmptyResults
            icon={AppReview}
            wrapperProps={{ p: '40px' }}
            iconProps={{ w: '150px', h: '150px', mb: '0px' }}
            subText="looks empty in here"
            text={`No ${title.toLowerCase()} found`}
          />
        )}
      </AccordionPanel>
    </AccordionItem>
  );
};
